import {toast} from "react-toastify";

export const fileTypePdfOrNot = (file) => {
    if (file.type === 'application/pdf') {
        return true;
    } else {
       toast.error("Invalid PDF File!");
       return false;
    }
}
